import React from 'react'
import { composeRefs } from '../utils/compose-refs'

export const HiddenFileInput = React.forwardRef<
  HTMLInputElement,
  {
    value: File | File[] | null | undefined
    name: string | undefined
    form?: string | undefined
    isRequired?: boolean
  }
>(({ value, name, form, isRequired }, ref) => {
  const fileInputRef = React.useRef<HTMLInputElement>(null)
  React.useEffect(() => {
    if (fileInputRef.current) {
      const dt = new DataTransfer()
      if (Array.isArray(value)) {
        value.forEach((v) => dt.items.add(v))
      } else if (value) {
        dt.items.add(value)
      }
      fileInputRef.current.files = dt.files
    }
  }, [value])

  return (
    <input
      style={{ display: 'none' }}
      type="file"
      tabIndex={-1}
      aria-hidden="true"
      onChange={() => {}}
      ref={composeRefs(fileInputRef, ref)}
      name={name}
      form={form}
      aria-required={isRequired}
      required={isRequired}
    />
  )
})
HiddenFileInput.displayName = 'HiddenFileInput'
